import { render } from "./Menu.vue?vue&type=template&id=59d13541&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=59d13541&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59d13541"

export default script